export default "__VITE_ASSET__39a381b5__"